/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  CardActionArea,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import cloneDeep from 'lodash/cloneDeep';
import { productCardStyle } from '../../css/style';
import { CARD_MENU_POSITION } from '../../data/Constants';

const styles = productCardStyle();

class TaxCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      anchorEl: null,
    };
  }

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null, isMenuOpen: false });
  }

  onClickDuplicate = (data) => {
    const {
      actions,
      apiToken,
      onClickDuplicate,
    } = this.props;
    const dataCopy = cloneDeep(data);
    dataCopy.name = `Copy of ${dataCopy.name}`;
    delete dataCopy.integrationPLU;
    delete dataCopy.locationIds;
    delete dataCopy.id;
    actions.addResource(apiToken, dataCopy, 'taxes').then(() => {
      onClickDuplicate();
      this.handleMenuClose();
    });
  };

  getLocationsDisplayValue = (locations) => {
    const { tax } = this.props;
    let filteredLocations = [];
    if (!Array.isArray(locations) || !Array.isArray(tax.locationIds)) return 'All locations';
    filteredLocations = tax.locationIds && tax.locationIds.map((locationId) => {
      const locId = get(locationId, 'id', locationId);
      const locationInfo = locations.find(location => `${location.id}` === `${locId}`);
      if (!locationInfo || !locationInfo.name) return '';
      return locationInfo.name;
    });
    const filteredList = filteredLocations.filter(name => !!(name));
    if (filteredList.length === locations.length || filteredList.length === 0) {
      return 'All locations';
    }
    return filteredList.join('\n\r');
  }

  render() {
    const {
      tax,
      onClickEdit,
      locations,
    } = this.props;
    const { anchorEl, isMenuOpen } = this.state;
    return (
      <Card style={tax.disabled ? styles.disabledCard : styles.cardStyle}>
        <CardContent style={styles.cardContentStyle}>
          <div style={styles.cardContentChildStyle}>
            <CardActionArea onClick={onClickEdit} style={styles.taxCardActionAreaStyle}>
              <div style={styles.actionAreaStyle}>
                <Typography style={styles.taxNameTextStyle}>
                  {tax.name}
                </Typography>
                <Typography style={styles.percentageTextStyle}>
                  {`${tax.percentage}%`}
                </Typography>
                <Typography style={styles.locationsTextStyle}>
                  {this.getLocationsDisplayValue(locations)}
                </Typography>
              </div>
            </CardActionArea>
            <IconButton
              style={styles.threeDotStyle}
              onClick={event => this.handleMenuOpen(event)}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id={tax.id}
              open={isMenuOpen}
              anchorEl={anchorEl}
              onClose={() => this.handleMenuClose()}
              getContentAnchorEl={null}
              anchorOrigin={CARD_MENU_POSITION}
              transformOrigin={CARD_MENU_POSITION}
            >
              <MenuItem onClick={onClickEdit}>Edit</MenuItem>
              <MenuItem onClick={() => this.onClickDuplicate(tax)}>Duplicate</MenuItem>
            </Menu>
          </div>
        </CardContent>
      </Card>
    );
  }
}

TaxCard.propTypes = {
  tax: PropTypes.objectOf(PropTypes.any).isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  onClickDuplicate: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
};

TaxCard.defaultProps = {
  locations: null,
};

export default TaxCard;
